import { lazy, Suspense } from 'react';
import type { MonthBarsProps } from './month-bars.js';
import styles from './month-bars.module.css';

const LoadedMonthBars = lazy(async () => {
  const barsModule = await import('./month-bars.js');
  return { default: barsModule.MonthBars };
});

export const LazyMonthBars = (props: MonthBarsProps) => (
  <Suspense fallback={<div className={styles.chart} />}>
    <LoadedMonthBars {...props} />
  </Suspense>
);
